export enum Experiments {
  ManageBadgesButtonInMainTab = 'specs.membersArea.ManageBadgesButton',
  RefreshWidgetsOnSettingsChange = 'specs.membersArea.RefreshWidgetsOnSettingsChange',
  ViewerCustomProfile = 'specs.membersArea.viewerCustomProfile',
  UrlMembersArea = 'specs.membersArea.urlMembersArea',
}
